import { leadsRetrieveOptions, ReturnLeadReadable } from '@crm/api'
import { useQuery } from '@tanstack/react-query'
import { createContext, PropsWithChildren } from 'react'

type ContextType = 'lead' | 'opportunity'

interface OpportunityContextState {
  lead?: ReturnLeadReadable
  isLoading: boolean
  type: ContextType
}

const defaultContextValue: OpportunityContextState = {
  lead: undefined,
  isLoading: false,
  type: 'lead'
}

type Props = {
  type?: ContextType
  id?: string
}

export const OpportunityContext =
  createContext<OpportunityContextState>(defaultContextValue)

export const OpportunityContextProvider = ({
  type = 'lead',
  id,
  children
}: PropsWithChildren<Props>) => {
  const { data, isLoading } = useQuery({
    ...leadsRetrieveOptions({ path: { id: Number(id) } }),
    enabled: !!id
  })

  return (
    <OpportunityContext.Provider
      value={{
        lead: data,
        isLoading,
        type
      }}
    >
      {children}
    </OpportunityContext.Provider>
  )
}
